import type { Task } from "@/api/tasks";
import { applyFramePatch } from "@/lib/frame-ingest";
import { useFramesStore } from "@/stores/frames-store";

/** Task binding changes the ticket, never the child conversation or its frame. */
export function rebindReplacedTaskFrames(
  task: Task & { replaces_task_id?: string },
) {
  const replaced = task.replaces_task_id;
  if (!replaced || replaced === task.id) return;
  const { framesById, frameOrder } = useFramesStore.getState();
  for (const id of frameOrder) {
    const frame = framesById[id];
    if (!frame) continue;
    const { metadata, taskTicket } = frame;
    if (
      frame.frameType !== "conversation" ||
      (metadata.taskId !== replaced &&
        metadata.task_id !== replaced &&
        taskTicket?.id !== replaced)
    )
      continue;
    applyFramePatch(id, {
      metadata: {
        ...metadata,
        taskId: task.id,
        ...(metadata.task_id ? { task_id: task.id } : {}),
      },
      task_id: task.id,
      task_ticket_number: task.ticket_number,
      task_title: task.title,
    });
  }
}
